export default __webpack_public_path__ + "static/media/Welcome.991993b8.svg";